import { useSelector } from 'react-redux';

import {
  selectSessionUserId,
  useFetchContentPreferencesQuery,
  useFetchEpisodeFacetsQuery,
} from '@/store';

export const useRegionPreferenceManagement = () => {
  const userId = useSelector(selectSessionUserId);

  const { data: facets } = useFetchEpisodeFacetsQuery();
  const { data: contentPreferences } = useFetchContentPreferencesQuery(
    undefined,
    { skip: !userId },
  );

  const regionOptions = facets?.entities['audience_region']?.values;
  const selectedRegions = contentPreferences?.audienceRegions;

  return {
    regionOptions,
    selectedRegions,
  };
};
